"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MemoryClipboard = /** @class */ (function () {
    function MemoryClipboard() {
    }
    MemoryClipboard.createElement = function (type) {
        return document.createElement(type);
    };
    MemoryClipboard.copy = function (str) {
        var input = MemoryClipboard.createElement("textarea");
        input.style.opacity = "0";
        input.style.position = "fixed";
        input.style.top = "0";
        input.style.left = "0";
        input.innerHTML = str;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        input.parentElement.removeChild(input);
        input = null;
    };
    return MemoryClipboard;
}());
exports.default = MemoryClipboard;
